import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";

@Injectable({
  providedIn: "root",
})
export class CategoriesService {
  apiUrl = "";
  //JSON.parse(localStorage.getItem('client'))['apiUrl'] || environment.apiUrl;
  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }
  createCategory(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/createCategory", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updateCategory(data, categoryId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "inventory/updateCategory?categoryID=" + categoryId,
        data,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  getCategoryDetails(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "inventory/getCategoriesAggregator?start=1&limit=&subCategories=true",
        data,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  getAllCategories(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "inventory/getCategoriesAggregator?start=1&limit=100&subCategories=true",
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  getAllCategoriesPage(start, pagesize, search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl +
          "inventory/getCategoriesAggregator?subCategories=true&start=" +
          start +
          "&limit=" +
          pagesize,
        search,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  //Auto Completetion Service Category

  getCategoryByName(term: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "inventory/searchCategories",
        { search: { name: term } },
        {
          headers: headers,
        },
      )
      .pipe(map((response) => response["Data"].slice(0, 10)));
  }
  checkCategoryByName(term: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "inventory/searchCategories",
        { search: { name: term } },
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  // Auto Complete Service Sub category
  getSubCategoryByName(term: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "inventory/searchSubCategories",
        { autosearchSub: term },
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"]
            .filter((option) => {
              return (
                option.name.toLowerCase().indexOf(term.toLowerCase()) === 0
              );
            })
            .slice(0, 10),
        ),
      );
  }
  createSubCategory(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/createSubCategory", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updateSubCategory(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/updateSubCategory", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteSubCategory(id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "inventory/removeSubCategory?subCategoryID=" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteCategory(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "inventory/removeCategory?categoryID=" + recordId, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getCategories(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "inventory/getCategories?start=1&limit=1000&subCategories=true",
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  getSubCategories(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/getSubCategoriesDetails", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  sortCategories(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/sortCategory", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getCategoriesBySeller(sellerId : any):Promise<any> {
     const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(`${this.apiUrl}inventory/getCategoriesSeller/${sellerId}`, {},{
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
